import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  HEALTHCARE_DOMAIN_INTRO,
  HEALTHCARE_GROUPS,
  HEALTHCARE_USE_CASES_SEO,
  HEALTHCARE_DOMAIN_FAQS,
  HEALTHCARE_ITEM_LIST_JSONLD,
  HEALTHCARE_BREADCRUMB_JSONLD,
  HEALTHCARE_WEBPAGE_JSONLD,
  HEALTHCARE_FAQ_JSONLD,
} from "../../data/rpa/healthcare-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = HEALTHCARE_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function HealthcareRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? HEALTHCARE_GROUPS
      : HEALTHCARE_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={HEALTHCARE_DOMAIN_INTRO}
        domainSlug="healthcare-domain"
        basePath="/rpa-use-cases"
        useCaseCount={HEALTHCARE_USE_CASES_SEO.length}
        groupCount={HEALTHCARE_GROUPS.length}
        itemListJsonLd={HEALTHCARE_ITEM_LIST_JSONLD}
        faqJsonLd={HEALTHCARE_FAQ_JSONLD}
        breadcrumbJsonLd={HEALTHCARE_BREADCRUMB_JSONLD}
        webPageJsonLd={HEALTHCARE_WEBPAGE_JSONLD}
        keywords="Healthcare automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{HEALTHCARE_DOMAIN_INTRO.title}</h1>
          {HEALTHCARE_DOMAIN_INTRO.content ? <p>{HEALTHCARE_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={HEALTHCARE_USE_CASES_SEO}
        groups={HEALTHCARE_GROUPS}
        heading="Healthcare Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={HEALTHCARE_DOMAIN_INTRO.title}
        domainFaqs={HEALTHCARE_DOMAIN_FAQS}
        useCases={HEALTHCARE_USE_CASES_SEO}
      />
    </div>
  );
}

